// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryChip_container__pRSnq","chip":"CategoryChip_chip__NTOCN","selected":"CategoryChip_selected__4LGUX"};